import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { environment } from '@environments/environment';
import { NGXLogger } from 'ngx-logger';
// import { interval } from 'rxjs';
import Swal from 'sweetalert2';
import { PortalStorageService } from './storage/portal-storage.service';
import { LookupStorageService } from './storage/lookup-storage.service';
import { DialogType } from '../helpers';
@Injectable({
    providedIn: 'root',
})
export class PwaUpdateService {
    public updateSubscription;
    public updateAvailable = false;

    constructor(
        private swUpdate: SwUpdate,
        private logger: NGXLogger,
        private portalStorageService: PortalStorageService,
        private lookupStorageService: LookupStorageService,
    ) {}

    public checkForUpdate(): boolean {
        this.updateSubscription = this.swUpdate.available.subscribe((event) => {
            this.updateAvailable = true;
            this.promptUser();
        });

        if (this.swUpdate.isEnabled) {
            // Required to enable updates on Windows and ios.
            this.swUpdate.activateUpdate();

            // Disabled interval until in app SWAL pop is working
            /* interval(60 * 60 * 1000).subscribe(() => {
                this.swUpdate.checkForUpdate().then(() => {
                    this.logger.log('Service Worker checking for update...');
                });
            }); */

            // One time check during inital load
            this.swUpdate.checkForUpdate().then(() => {
                this.logger.log('Service Worker checking for update...');
            });

            // Important: on Safari (ios) Heroku doesn't auto redirect links to their https which allows the installation of the pwa like usual
            // but it deactivates the swUpdate. So make sure to open your pwa on safari like so: visit ForSiteApp url then (Add to Home Page) manually
        }
        return this.updateAvailable;
    }

    promptUser(): void {
        this.swUpdate.activateUpdate().then(() => {
            // auto update
            /* this.swUpdate.activateUpdate().then(() => {
                window.location.reload();
            }); */

            // TODO: To be used with offline functionality
            // const updateMessage = '';
            const header = 'App Update';
            // const headerMessage = `<p class="m-b-0">New version ${environment.appVersion} available</p>`;
            const headerMessage = `<p class="m-b-0">New version available</p>`;
            // const bodyMessage = updateMessage !== '' && updateMessage !== null ? `<div class="dialog-message">${updateMessage}</div>` : '';
            Swal.fire({
                title: header,
                icon: DialogType.Info,
                html: `${headerMessage}`, // ${bodyMessage}`,
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: 'Update',
                buttonsStyling: false,
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-secondary',
                },
            }).then((confirm) => {
                if (confirm) {
                    //this.portalStorageService.clearAppAuthStorage();
                    this.lookupStorageService.clearLookupStorage();
                    window.location.reload();
                }
            });
            // Confirmation message
            /* const question = 'Would you like to update now?';
            Swal.fire({
                title: header,
                html: `${headerMessage}<p class="pt-2">${question}</p>`,
                type: 'question',
                showCloseButton: true,
                showCancelButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
            }).then((willContinue) => {
                if (!willContinue.dismiss) {
                    window.location.reload();
                }
            }); */
        });
    }
}
